/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>导购工具</el-breadcrumb-item>
      <el-breadcrumb-item>签约管理详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form class="user-search">
          <el-form-item>
            <el-button size="small" type="primary" @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
        <div class="titlelist" v-if="energylist"><div class="icons"></div>签约信息</div>
		<div class="listout" v-if="energylist">
			<div class="list">
				<div class="listleft">签约方式：{{energylist.signType}}</div>
			</div>
			<div class="list">
				<div class="listleft">驻镇代表开发数量：{{energylist.meetingTime}}</div>
			</div>
			<div class="list">
				<div class="listleft">订购的会场次数：{{energylist.meetingTime}}</div>
			</div>
			<div class="list">
				<div class="listleft">成交台数：{{energylist.turnoverNum}}</div>
			</div>
			
			
		</div>
		
		<div class="listout" v-if="energylist">
			<div class="list">
				<div class="listleft">意向客户数量：{{energylist.potentialNum}}</div>
			</div>
			<div class="list">
				<div class="listleft">开始时间：{{energylist.startDate}}</div>
			</div>
			<div class="list">
				<div class="listleft">结束时间：{{energylist.endDate}}</div>
			</div>
			<div class="list">
				<div class="listleft">备注：{{energylist.remark}}</div>
			</div>
			
			
		</div>
		
		<div class="listout" v-if="energylist">
			<div class="listleft">签约方式{{energylist.signType}}</div>
		</div>
		<div class="listouts" v-if="energylist">
			<div class="list1">
				  <div class="imglist" v-for="(item,index) in resultFilelist">
					  <img :src="item.fileTemporaryUrl" @click="clickimg(item.fileTemporaryUrl)" />
				  </div>
			</div>
			
			
		</div>
		
		
		
		
		<div class="titlelist" v-if="representlist"><div class="icons"></div>签约信息</div>
		<div class="listout" v-if="representlist">
			<div class="list">
				<div class="listleft">签约方式：{{representlist.signType}}</div>
			</div>
			<div class="list">
				<div class="listleft">签约人姓名：{{representlist.info.secondPartyName}}</div>
			</div>
			<div class="list">
				<div class="listleft">签约人电话：{{representlist.info.secondPartyPhone}}</div>
			</div>
			<div class="list">
				<div class="listleft">聘用乡镇：{{representlist.info.employTownName}}</div>
			</div>
			
			
		</div>
		
		<div class="listout" v-if="representlist">
			<div class="list">
				<div class="listleft">地址：{{representlist.info.secondPartyAddr}}</div>
			</div>
			<div class="list">
				<div class="listleft">开始时间：{{representlist.info.startDate}}</div>
			</div>
			<div class="list">
				<div class="listleft">结束时间：{{representlist.info.endDate}}</div>
			</div>
			<div class="list">
				<div class="listleft">底薪：{{representlist.info.baseSalary}}</div>
			</div>
			
			
		</div>
		
		<div class="listout" v-if="representlist">
			<div class="list">
				<div class="listleft">按月支付责任报酬：{{representlist.info.monthlyReward}}元</div>
			</div>
			<div class="list">
				<div class="listleft">采暖机成交奖励：{{representlist.info.heatingMachineTurnover}}元/台</div>
			</div>
			<div class="list">
				<div class="listleft">热水机成交奖励按：{{representlist.info.waterHeaterTurnover}}元/台</div>
			</div>
			<div class="list">
				<div class="listleft">每月几日共同确认上月任务完成数：{{representlist.info.confirmTaskNum}}日</div>
			</div>
			
			
		</div>
		
		<div class="titlelist" v-if="representlist"><div class="icons"></div>指标信息</div>
		<div class="listouts" v-if="representlist">
			<div class="liststable">
				<div class="tableout">
					<div class="tablelist">拜访量</div>
					<div class="tabletitle">
						<div class="tabileleft">日目标</div>
						<div class="tabileright">月目标</div>
					</div>
					<div class="tablelists">
						<div class="tabileleft">{{representlist.indicDto.dailyVisitIndic}}</div>
						<div class="tabileright">{{representlist.indicDto.dailyVisitIndic}}</div>
					</div>
				</div>
			</div>
			
			<div class="liststable">
				<div class="tableout">
					<div class="tablelist">单页发放量</div>
					<div class="tabletitle">
						<div class="tabileleft">日目标</div>
						<div class="tabileright">月目标</div>
					</div>
					<div class="tablelists">
						<div class="tabileleft">{{representlist.indicDto.dailySinglePageIndic}}</div>
						<div class="tabileright">{{representlist.indicDto.monthlySinglePageIndic}}</div>
					</div>
				</div>
			</div>
			
			<div class="liststable">
				<div class="tableout">
					<div class="tablelist">海报黏贴量</div>
					<div class="tabletitle">
						<div class="tabileleft">日目标</div>
						<div class="tabileright">月目标</div>
					</div>
					<div class="tablelists">
						<div class="tabileleft">{{representlist.indicDto.dailyPosterPasteIndic}}</div>
						<div class="tabileright">{{representlist.indicDto.monthlyPosterPasteIndic}}</div>
					</div>
				</div>
			</div>
			
			<div class="liststable">
				<div class="tableout">
					<div class="tablelist">意向客户量</div>
					<div class="tabletitle">
						<div class="tabileleft">日目标</div>
						<div class="tabileright">月目标</div>
					</div>
					<div class="tablelists">
						<div class="tabileleft">{{representlist.indicDto.dailyIntendUserIndic}}</div>
						<div class="tabileright">{{representlist.indicDto.monthlyIntendUserIndic}}</div>
					</div>
				</div>
			</div>
			
			
		</div>
		
		
		<div class="listouts" v-if="representlist">
			<div class="liststable">
				<div class="tableout">
					<div class="tablelist">参与地推活动量</div>
					<div class="tabletitle">
						<div class="tabileleft">日目标</div>
						<div class="tabileright">月目标</div>
					</div>
					<div class="tablelists">
						<div class="tabileleft">{{representlist.indicDto.dailyActivityIndic}}</div>
						<div class="tabileright">{{representlist.indicDto.monthlyActivityIndic}}</div>
					</div>
				</div>
			</div>
			
			
			<div class="liststable">
				<div class="tableout">
					<div class="tablelist">成交意向客户量</div>
					<div class="tabletitle">
						<div class="tabileleft">日目标</div>
						<div class="tabileright">月目标</div>
					</div>
					<div class="tablelists">
						<div class="tabileleft">{{representlist.indicDto.dailyDealUserIndic}}</div>
						<div class="tabileright">{{representlist.indicDto.monthlyDealUserIndic}}</div>
					</div>
				</div>
			</div>
			
			
		</div>
		
		
		
		<div class="titlelist" v-if="customerlist"><div class="icons"></div>签约信息</div>
		<div class="listout" v-if="customerlist">
			<div class="list">
				<div class="listleft">签约方式：{{customerlist.signType}}</div>
			</div>
			<div class="list">
				<div class="listleft">客户姓名：{{customerlist.info.name}}</div>
			</div>
			<div class="list">
				<div class="listleft">客户电话：{{customerlist.info.phone}}</div>
			</div>
			<div class="list">
				<div class="listleft">客户地址：{{customerlist.info.addr}}</div>
			</div>
			
			
		</div>
		
		<div class="listout" v-if="customerlist">
			<div class="list">
				<div class="listleft">合同金额：{{customerlist.info.amount}}</div>
			</div>
			
		</div>
		<div class="listout" v-if="customerlist">
			<div class="listleft">签约方式{{customerlist.signType}}</div>
		</div>
		<div class="listout" v-if="customerlist">
			<div class="list1">
				  <div class="imglist" v-for="(item,index) in resultFilelist">
					  <img :src="item.fileTemporaryUrl"/>
				  </div>
			</div>
			
			
		</div>
		
		
		<div class="titlelist" v-if="customerlist"><div class="icons"></div>产品明细</div>
		<div v-for="(item,index) in customerlist.productInfoList" v-if="customerlist">
			<div class="listout" >
				<div class="list">
					<div class="listleft">产品名称：{{item.name}}</div>
				</div>
				<div class="list">
					<div class="listleft">产品型号：{{item.model}}</div>
				</div>
				<div class="list">
					<div class="listleft">产品数量：{{item.amount}}</div>
				</div>
				<div class="list">
					<div class="listleft">产品价格：{{item.unitPrice}}</div>
				</div>
				
			</div>
			
			<div class="listout" >
				<div class="list">
					<div class="listleft">产品总价：{{item.totalPrice}}</div>
				</div>
				<div class="list">
					<div class="listleft">备注：{{item.remark}}</div>
				</div>
				
				
			</div>
		</div>
		
		<div class="titlelist" v-if="customerlist"><div class="icons"></div>收货信息</div>
		<div class="listout" v-if="customerlist">
			<div class="list">
				<div class="listleft">收货人：{{customerlist.otherInfo.receiver}}</div>
			</div>
			<div class="list">
				<div class="listleft">收货地址：{{customerlist.otherInfo.receiveAddr}}</div>
			</div>
			<div class="list">
				<div class="listleft">收货人电话：{{customerlist.otherInfo.receivePhone}}</div>
			</div>
			
			
		</div>
		
		<div class="titlelist" v-if="customerlist"><div class="icons"></div>支付方式</div>
		<div class="listout" v-if="customerlist">
			<div class="list">
				<div class="listleft">支付方式：{{customerlist.otherInfo.payMode}}</div>
			</div>
			<div class="list">
				<div class="listleft">签订之日起：{{customerlist.otherInfo.signDay}}</div>
			</div>
			<div class="list">
				<div class="listleft">订单总金额：{{customerlist.otherInfo.amountPercent}}</div>
			</div>
			<div class="list">
				<div class="listleft">卖方户名：{{customerlist.otherInfo.bankName}}</div>
			</div>
			
			
		</div>
		
		<div class="listout" v-if="customerlist">
			<div class="list">
				<div class="listleft">卖方开户银行：{{customerlist.otherInfo.bank}}</div>
			</div>
			<div class="list">
				<div class="listleft">卖方银行账号：{{customerlist.otherInfo.bankAccount}}</div>
			</div>
			<div class="list">
				<div class="listleft">运输方式：{{customerlist.otherInfo.transportType}}</div>
			</div>
			<div class="list">
				<div class="listleft">运费承担方：{{customerlist.otherInfo.fightBear}}</div>
			</div>
			
			
		</div>
		
		<el-dialog
		  title=""
		  :visible.sync="centerDialogVisible"
		  width="70%"
		  center>
		  <img class="imgUrls" :src="imgUrls"/>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="centerDialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
		  </span>
		</el-dialog>
		
		
      </div>
    </template>

    <script>
	// 导入请求方法
	import { uploadFile } from '../../api/axiosFun';
    import {
      getsigndetail,
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
          list:[],
		  resultFilelist:[],
		  lists:[],
		  fileList: [],
		  types:'',
		  energylist:'',
		  customerlist:'',
		  representlist:'',
          centerDialogVisible: false,
		  imgUrls:''
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        //this.getData(this.formProInfo)

      },
      mounted(){
		  this.id = this.$route.query.id
		  this.types = this.$route.query.types
		  this.handleEdit()
		  
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		clickimg(e){
			this.imgUrls = e
			this.centerDialogVisible  = true
		},
		  //显示编辑界面
		  handleEdit: function() {
		    let _this = this
		   getsigndetail(this.id,this.types).then(res => {
		       console.log(res)
		       this.loading = false
		       if (res.success == false) {
		         this.$message({
		           type: 'info',
		           message: res.msg+'TraceId:'+res.traceId
		         })
		       } else {
		         console.log(res)
		         this.list = res.data
				 if(this.types=='energy'){
					 this.energylist = res.data
					 this.resultFilelist = this.energylist.mediaObjInfoList
				 }else if(this.types=='customer'){
					 this.customerlist = res.data
					 this.resultFilelist = this.customerlist.mediaObjInfoList
				 }else if(this.types=='represent'){
					 this.representlist = res.data
				 }
				  
				
					 
				 }
				 
		   		  
		         
		     })
		   
		   
		  },
		 
		//编辑
		goback() {
			this.$router.push({ path: '/sign'})
		 
		},
		

      }
    }
    </script>

    <style scoped>
	.listout{
		width: 96%;
		display: flex;
		margin: 0 auto;
		margin-top: 20px;
		font-size: 14px;
	}
	.listout1{
		width: 96%;
		display: flex;
		margin: 0 auto;
		margin-top: 20px;
		font-size: 14px;
		height: 40px;
	}
	.list{
		width: 25%;
		height: 20px;
		line-height: 20px;
		text-align: left;
		display: flex;
	}
	.list1{
		width: 100%;
		display: flex;
	}
	.imglist{
		margin-right: 10px;
	}
	.lists{
		width: 40%;
		height: 20px;
		line-height: 20px;
		text-align: left;
	}
	
	.titlelist{
		margin: 0 auto;
		height: 30px;
		text-align: left;
		line-height: 30px;
		margin-top: 40px;
		padding-left: 10px;
		width: 96%;
		position: relative;
	}
	.icons{
		height: 22px;
		width: 4px;
		border-radius: 10px;
		background-color: #000;
		position: absolute;
		left: 0;
		top: 4px;
	}
    .user-search {
		position: absolute;
		top: 20px;
		right: 0px;
		width: 100px;
    }
	.user-searchs {
	  margin-top: 20px;
	}
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .editForm{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 600px;
	  
  }
  .el-select{
	  width: 100%;
  }
  .dialog-footer{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 480px;
	  padding-left: 120px;
  }
  .title{
	  width: 100%;
  }
  .tableout{
	  width: 95%;
	  height: 120px;
	  border: 1px solid #d9d9d9;
	  border-radius: 5px;
	  font-size: 14px;
  }
  .tablelist{
	  width: 100%;
	  height: 40px;
	  line-height: 40px;
	  text-align: center;
	  
  }
  .tablelists{
  	  width: 100%;
  	  height: 40px;
  	  line-height: 40px;
  	  text-align: center;
  	  display: flex;
  	  
  }
  .tabletitle{
	  width: 100%;
	  height: 40px;
	  line-height: 40px;
	  text-align: center;
	  display: flex;
	  background-color: #ebe8e8;
  }
  .tabileleft{
	  width: 50%;
	  text-align: center;
	  
  }
  .tabileright{
	  width: 50%;
	  text-align: center;
  }
  .liststable{
  	width: 25%;
  }
  .listouts{
  	width: 96%;
  	display: flex;
  	margin: 0 auto;
  	margin-top: 20px;
  }
  .imglist img{
	  width: 150px;
	  height: 150px;
	 
  }
  .imgUrls{
	  width: 100%;
	  height: auto;
  }
    </style>





// WEBPACK FOOTER //
// src/views/guidetool/signadd.vue